import React from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ActionIcon, Container, Grid, Text, useMantineTheme, Box, Modal, TextInput, Loader, SimpleGrid, Card, ScrollArea } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';

import { useLoginContext } from "../context/loginContext";

import { utils, BE_API_THREE, tabProject, menuList, subMenuProject, role } from "../utils/globalVariables";
import { safetyDecodeJWT, getPropInSubLevelRole, stringDivider, safeValue, sqlDateToHumanDate, getObjectParam2 } from "../utils/globalFunctions";
import { stepsCanBeAccessedByTeknisiQuickSearch } from "../utils/accessing";

import LabelContentInline from "../components/general/LabelContentInline";

const PencarianCepatModal = () => {

  const mountedRef = React.useRef(true);

  const navigate = useNavigate();
  const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'PencarianCepatModal-1',
  })

  const [data, setData] = React.useState({
    modal: false,
    searchInput: '',

    data: [],
    dataFlag: 'idle',
    dataLoading: false,
  })

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const handleSearch = () => {
    setData(d => ({ ...d, dataLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('flag_all', utils.flagAll);
    formDT.append('filter_search', data.searchInput);

    axios({
      method: 'post',
      url: BE_API_THREE + '/quick_search',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataLoading: false }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          data: response.data.data,
          dataFlag: response.data.data.length > 0 ? true : false,
        }));
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        dataLoading: false,
      }));

      notifications.show({
        id: notificationId.current.errorGetData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  const handleSelectedProject = (stateProjectId, stateCustomerId, stateProjectStep) => {
    setData(d => ({ ...d, modal: false }));

    let tab = '';

    if (stateProjectStep === utils.projectProcess.nota.value) {
      tab = tabProject.nota;
    } else if (stateProjectStep === utils.projectProcess.antrian.value) {
      tab = tabProject.antrian;
    } else if (stateProjectStep === utils.projectProcess.pengerjaan.value) {
      tab = tabProject.pengerjaan;
    } else if (stateProjectStep === utils.projectProcess.qc.value) {
      tab = tabProject.qc;
    } else if (stateProjectStep === utils.projectProcess.selesai.value) {
      tab = tabProject.selesai;
    } else if (stateProjectStep === utils.projectProcess.sudah_diambil.value) {
      tab = tabProject.sudahDiambil;
    }

    navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${menuList.project.slug}/${subMenuProject}/${tab}/${stateProjectStep === utils.projectProcess.nota.value ? stateCustomerId : stateProjectId}`, { replace: true });
  }

  return (
    <React.Fragment>
      <ActionIcon
        variant='subtle'
        radius='xl'
        size='lg'
        sx={{
          border: 0,
          color: theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.gray[2]
        }}
        onClick={() => setData(d => ({ ...d, modal: true }))}
        title='Pencarian Cepat'
      >
        <IconSearch
          size={20}
          strokeWidth={1.5}
        />
      </ActionIcon>

      <Modal
        opened={data.modal}
        onClose={() => setData(d => ({ ...d, modal: false }))}
        title="Pencarian Cepat Project"
        size='lg'
        scrollAreaComponent={ScrollArea.Autosize}
        overlayProps={{
          color: theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[9],
          opacity: 0.35,
          blur: 3,
        }}

        closeButtonProps={{
          size: 'md',
          radius: 'xl'
        }}
      >
        <TextInput
          styles={(tema) => ({
            rightSection: {
              backgroundColor: tema.colorScheme === 'light' ? tema.colors.blue[5] : tema.colors.blue[8],
              borderTopRightRadius: tema.radius.md,
              borderBottomRightRadius: tema.radius.md,
              cursor: 'pointer',
            },
            input: {
              backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[5]
            }
          })}

          rightSection={
            data.searchInput &&
            <IconSearch
              size='1rem'
              color='#fff'
            />
          }

          rightSectionProps={{
            onClick: handleSearch
          }}

          variant='default'
          size='sm'
          radius='md'
          placeholder='Search Project'
          value={data.searchInput}
          onChange={(e) => setData(d => ({ ...d, searchInput: e.target.value }))}
          onKeyUp={(e) => e.key === 'Enter' && handleSearch()}

          py={0}
          my={0}
        />

        {data.dataLoading &&
          <Box ta='center' mt='lg'>
            <Text size='sm' color='dimmed' mb='.5rem'>Loading..</Text>
            <Loader variant="bars" size="sm" />
          </Box>
        }

        {!data.dataLoading && data.dataFlag === 'idle' &&
          <Box ta='center' mt='lg'>
            <Text size='sm' color='dimmed' mb='.5rem'>
              Cari project dengan mengisi nomor nota, nama customer, nama barang atau data yang ingin Anda cari.
            </Text>
          </Box>

        }

        {!data.dataLoading && Array.isArray(data.data) && (data.data.length <= 0) && data.dataFlag === false &&
          <Box ta='center' mt='lg'>
            <Text size='sm' color='dimmed' mb='.5rem'>Data tidak ditemukan.</Text>
          </Box>
        }

        {!data.dataLoading && Array.isArray(data.data) && (data.data.length > 0) && data.dataFlag === true &&
          <Container fluid mt='lg' px={0}>
            <Grid my={0}>
              <Grid.Col
                span={12}
                py={0}
              >
                <SimpleGrid
                  cols={1}
                  spacing='md'
                  breakpoints={[
                    { minWidth: 'xl', cols: 2, spacing: 'md' },
                    { minWidth: 'lg', cols: 2, spacing: 'md' },
                    { minWidth: 'md', cols: 2, spacing: 'md' },
                    { minWidth: 'sm', cols: 2, spacing: 'md' },
                    { minWidth: 'xs', cols: 1, spacing: 'md' },
                  ]}
                >
                  {Object.keys(data.data).map((key, index) => {
                    return (
                      <Card
                        key={key}
                        shadow=''
                        radius="md"
                        withBorder={true}

                        style={{
                          borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[6],
                          backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[0] : theme.colors.dark[6],
                          overflow: 'unset',
                          cursor: 'pointer',
                        }}

                        onClick={
                          ((safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappl') !== role.teknisi.slugLevel) || (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappl') === role.teknisi.slugLevel && stepsCanBeAccessedByTeknisiQuickSearch({ stateStep: data.data[key].project_process }))) ?
                            () => {
                              handleSelectedProject(data.data[key].project_id, data.data[key].customer_id, data.data[key].project_process)
                            }
                            :
                            () => { }
                        }
                      >
                        <Card.Section p='sm'>
                          <Text size="sm">

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='No Nota'
                              stateContent={
                                <React.Fragment>
                                  <Text>
                                    {stringDivider(data.data[key].project_id, [4, 6, 8], '.', '[Nomor Nota]')}
                                  </Text>

                                  <Text>
                                    {getObjectParam2(utils.projectProcess, data.data[key].project_process, 'caption', ' - ')}
                                  </Text>
                                </React.Fragment>
                              }
                              stateDivider={false}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='Customer'
                              stateContent={
                                <React.Fragment>
                                  <Text lineClamp={1}>
                                    {safeValue(data.data[key].customer_name, '-')}
                                  </Text>

                                  <Text lineClamp={1}>
                                    {safeValue(data.data[key].customer_category_name, '-')}
                                  </Text>
                                </React.Fragment>
                              }
                              stateDivider={false}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='Barang'
                              stateContent={
                                <React.Fragment>
                                  <Text lineClamp={1}>
                                    {safeValue(data.data[key].barang_category_name, '-')}
                                  </Text>

                                  <Text lineClamp={1}>
                                    {safeValue(data.data[key].barang_nama, '-')}
                                  </Text>
                                </React.Fragment>
                              }
                              stateDivider={false}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='Keluhan'
                              stateContent={
                                <Text lineClamp={2}>
                                  {safeValue(data.data[key].barang_keluhan, '-')}
                                </Text>
                              }
                              stateDivider={false}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='Tgl Nota'
                              stateContent={sqlDateToHumanDate({
                                stateDate: data.data[key].tanggal_nota,
                                stateWithTime: false,
                                stateLang: 'id',
                                stateIsShort: true,
                                stateDay: false,
                                stateDefaultValue: ' - ',
                                stateDateType: 'day'
                              })}
                              stateDivider={false}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='Teknisi'
                              stateContent={
                                <Box>
                                  <Text lineClamp={1}>
                                    {safeValue(data.data[key].penerima_rekomendasi_nama, '-')}
                                  </Text>

                                  {data.data[key].recommendation_info &&
                                    <Text lineClamp={1}>
                                      {safeValue(data.data[key].recommendation_info, '-')}
                                    </Text>
                                  }
                                </Box>
                              }
                              stateDivider={false}
                            />
                          </Text>
                        </Card.Section>
                      </Card>
                    )
                  })}
                </SimpleGrid>
              </Grid.Col>
            </Grid>
          </Container>
        }
      </Modal>
    </React.Fragment >
  )
}

export default React.memo(PencarianCepatModal);